import { ChaordicService } from 'core/chaordic/chaordic.service'
import { VitrineObserver } from './vitrine.observer'
import { Observable } from 'rxjs'
import { Scroll } from 'components/scroll'
import inView from 'in-view'

export class VitrineComponent {
    constructor() {
        this.vitrineClass = ".vitrine"
        this.btnVitrineElement = document.querySelectorAll('[data-click="openVitrine"]')
        this.btnVitrineClearHistory = document.querySelectorAll('[data-click="clearHistory"]')
        this.btnVitrineCustomElement = document.querySelectorAll('[data-click="openVitrineCustomLayout"]')
        this.btnVitrineHome = document.querySelectorAll('[data-vitrine="descobrirMais"]')
        this.service = new ChaordicService();
        this.init()
    }

    init() {
        if(this.btnVitrineElement) {
            Array.prototype.forEach.call(this.btnVitrineElement, btnVitrine => {
                let vitrineClickStream = Observable.fromEvent(btnVitrine, 'click')
                vitrineClickStream
                    .debounceTime(200)
                    .map(event => event.target.closest('.vitrine'))
                    //.do(event => event.target.style.display = 'none')
                    .subscribe(new VitrineObserver())
            })
        }

        if(this.btnVitrineClearHistory){
            Array.prototype.forEach.call(this.btnVitrineClearHistory, btnVitrine => {
                let vitrineClickStream = Observable.fromEvent(btnVitrine, 'click')
                vitrineClickStream
                    .debounceTime(200)
                    .subscribe(e => {
                        var vitrineHistory = document.querySelector(".vitrine.vitrine--history");
                        vitrineHistory.parentNode.removeChild(vitrineHistory);
                        document.cookie='LojaVirtualPanvelProdutosVisualizados=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                        document.cookie='LojaVirtualPanvelTermosPesquisados=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    })
            })
            
        }

        if(this.btnVitrineCustomElement) {
            Array.prototype.forEach.call(this.btnVitrineCustomElement, btnVitrine => {
                let vitrineClickStream = Observable.fromEvent(btnVitrine, 'click')
                vitrineClickStream
                    .debounceTime(200)
                    .subscribe(e => {
                        const vitrinesHidden = Array.from(document.querySelectorAll('.vitrine__results')).filter(this.isHidden)
                        const vitrines = Array.from(document.querySelectorAll('.vitrine__results')).filter(this.isBlock)
                        
                        if(vitrines.length > 0){
                            vitrines[vitrines.length - 1].nextElementSibling.style.display = 'block'
                            new Scroll(vitrines[vitrines.length - 1].nextElementSibling.offsetTop + 420, 300)
                        }
                        
                        if(vitrinesHidden.length == 1)
                            e.target.style.display = 'none'
                    })
            })
        }

        if(this.btnVitrineHome) {
            Array.prototype.forEach.call(this.btnVitrineHome, btnVitrine => {
                let vitrineClickStream = Observable.fromEvent(btnVitrine, 'click')
                vitrineClickStream
                    .debounceTime(200)
                    .subscribe(e => {
                        const vitrineContainer = document.querySelector('.vitrine-container');
                        if(vitrineContainer) {
                            const vitrinesHidden = Array.from(vitrineContainer.querySelectorAll('.vitrine-section')).filter(this.isHidden)
                            const vitrines = Array.from(vitrineContainer.querySelectorAll('.vitrine-section')).filter(this.isBlock)
                            
                            if(vitrines.length > 0){
                                vitrines[vitrines.length - 1].nextElementSibling.style.display = 'block'
                                new Scroll(vitrines[vitrines.length - 1].nextElementSibling.offsetTop - 150, 300)
                            }
                            
                            if(vitrinesHidden.length == 1)
                                e.target.style.display = 'none'

                        }
                    })
            })
        }

        //trigger impression event to chaordic
        //if half vitrine element is in viewport
        if(document.querySelector(this.vitrineClass)) {
            inView(this.vitrineClass)
                .on('enter', (el) => {
                    if(el && !el.getAttribute("data-chaordic-triggered")){
                        let url = el.getAttribute("data-chaordic-impression")
                        if(url) {
                            let vitrineEventStream = this.service.sendImpressionEvent(url)
                            vitrineEventStream
                                .subscribe(
                                    (res) => {
                                        el.setAttribute("data-chaordic-triggered", true)
                                    },
                                    (error) => {
                                        console.log("error sending impression event to chaordic", error)
                                    })
                        }
                    }
                })
            inView.threshold(0.5);//trigger if half of element is in viewport
        }
    }

    isBlock(element) {
        return (element.currentStyle ? element.currentStyle['display'] : window.getComputedStyle ? window.getComputedStyle(element, null).getPropertyValue('display') : null) === 'block';
    }

    isHidden(element) {
        return (element.currentStyle ? element.currentStyle['display'] : window.getComputedStyle ? window.getComputedStyle(element, null).getPropertyValue('display') : null) === 'none';
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/vitrine/vitrine.component.js